import { Alert, Snackbar } from '@mui/material';
import { SEVERITY } from '_constants/derived';
import React from 'react';

import { AlertMessageProps } from './types';

export const AlertMessage = ({
  message,
  open,
  severity = SEVERITY.success,
  onClose,
  hideDuration = 5000,
}: AlertMessageProps) => (
  <Snackbar
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    autoHideDuration={hideDuration}
    onClose={onClose}
    open={open}
  >
    <Alert onClose={onClose} severity={severity} variant="filled">
      {message}
    </Alert>
  </Snackbar>
);
